// src/components/layouts/PublicLayout.tsx
import React from "react";
import { Outlet } from "react-router-dom";

export default function PublicLayout() {
    return (
        <div className="h-full bg-gray-100">
            <Outlet />
        </div>
    );
}
